export default __webpack_public_path__ + "img/sec-6-bg.png";